import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";

const tocItems = [
    { id: "introduction", label: "1. Introduction" },
    { id: "eligibility", label: "2. Eligibility" },
    { id: "accounts", label: "3. Account Registration" },
    { id: "payments", label: "4. Payments & EMI Plans" },
    { id: "usage", label: "5. Acceptable Use" },
    { id: "termination", label: "6. Termination" },
    { id: "liability", label: "7. Limitation of Liability" },
    { id: "indemnity", label: "8. Indemnification" },
    { id: "governing", label: "9. Governing Law" },
    { id: "changes", label: "10. Changes to Terms" },
    { id: "contact", label: "11. Contact Us" },
];

const sectionContent = {
    introduction: `
These Terms and Conditions ("Terms") govern your use of the services provided by AZZ Enterprises, including our website and EMI offerings in partnership with DBS Bank. By accessing or using our services, you agree to these Terms.
  `,

    eligibility: `
You must be at least 18 years old and legally capable of entering contracts in your jurisdiction to use our services.
  `,

    accounts: `
You are responsible for maintaining the confidentiality of your account credentials. Any activities under your account are your responsibility.
  `,

    payments: `
All EMI payments are processed securely via our partnered financial institutions. You agree to repay your EMI as per the selected plan. Late or missed payments may result in additional charges or cancellation.
  `,

    usage: `
You agree not to misuse the service, including using it for illegal activities, distributing harmful content, or attempting unauthorized access to other systems.
  `,

    termination: `
We reserve the right to suspend or terminate your access if we believe you've violated these Terms or engaged in harmful behavior.
  `,

    liability: `
AZZ Enterprises will not be liable for any indirect, incidental, or consequential damages arising from your use of the service.
  `,

    indemnity: `
You agree to indemnify and hold harmless AZZ Enterprises from any claims, losses, or damages arising from your breach of these Terms.
  `,

    governing: `
These Terms are governed by the laws of Singapore. Any disputes shall be resolved in the courts of Singapore.
  `,

    changes: `
We may update these Terms occasionally. Continued use of our services constitutes your acceptance of the revised Terms.
  `,

    contact: `
For any questions regarding these Terms, please contact us at:

Email: support@azz.com.sg  
Phone: +65 1234 5678
  `,
};

const TermsAndConditions = () => {
    const [activeId, setActiveId] = useState("");

    useEffect(() => {
        const handleScroll = () => {
            const offset = 100;
            for (let i = tocItems.length - 1; i >= 0; i--) {
                const section = document.getElementById(tocItems[i].id);
                if (section && window.scrollY + offset >= section.offsetTop) {
                    setActiveId(tocItems[i].id);
                    break;
                }
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="d-flex flex-column min-vh-100 bg-white">
            <Helmet>
                <title>Terms & Conditions – AZZ Enterprises</title>
            </Helmet>

            <NavBar />

            <Container fluid className="py-5 px-3 px-lg-5" style={{ maxWidth: "1400px" }}>
                <Row>
                    <Col lg={8}>
                        <h1 className="fw-bold display-4 mb-2">Terms & Conditions</h1>
                        <p className="text-muted mb-5">Last updated July 1st, 2025</p>

                        <p className="lead text-dark mb-4">
                            These Terms and Conditions outline the rules and regulations for using AZZ Enterprises' services.
                        </p>

                        {tocItems.map(({ id, label }) => (
                            <section className="mb-5" id={id} key={id}>
                                <h5 className="fw-bold mb-3">{label}</h5>
                                <p className="text-muted" style={{ whiteSpace: "pre-line" }}>
                                    {sectionContent[id]}
                                </p>
                            </section>
                        ))}
                    </Col>

                    <Col lg={4} className="d-none d-lg-block">
                        <div className="sticky-top pt-2" style={{ top: "100px" }}>
                            <h6 className="text-dark mb-3 fw-bold">Table of contents</h6>
                            <ul className="list-unstyled small">
                                {tocItems.map(({ id, label }) => (
                                    <li className="mb-2" key={id}>
                                        <a
                                            href={`#${id}`}
                                            className={`text-decoration-none ${activeId === id ? "text-primary fw-semibold" : "text-muted"
                                                }`}
                                        >
                                            {label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            <a href="#top" className="text-muted small d-block mt-3">
                                ⬆ Back to top
                            </a>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Footer />
        </div>
    );
};

export default TermsAndConditions;
